import React from 'react';
import { API_BASE_URL } from '../../constants/config';

interface TeamMemberProps {
  name: string;
  description?: string;
  imageSrc?: string;
  link?: string;
}

export default function TeamMember({
  name,
  description,
  imageSrc,
  link,
}: TeamMemberProps) {
  const finalImage =
    imageSrc && imageSrc.trim() !== ''
      ? imageSrc
      : `${API_BASE_URL}/api/team_img/default.jpg`;

  const content = (
    <>
      <img
        src={finalImage}
        alt={name}
        className="w-32 h-32 rounded-full object-cover shadow-md mx-auto"
      />
      <h3 className="text-lg font-semibold transition-colors group-hover:text-blue-500">
        {name}
      </h3>
      <p className="text-sm">{description}</p>
    </>
  );

  return (
    <div className="flex flex-col items-center text-center space-y-4 transition-transform duration-200 hover:scale-105">
      {link ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="group text-inherit no-underline"
        >
          {content}
        </a>
      ) : (
        content
      )}
    </div>
  );
}
